import config from 'Config';
import { ONE_WEEK } from 'Lib/constants/time';

export const ADD_SESSION_ACTIVITY_TYPES = 'ADD_SESSION_ACTIVITY_TYPES';
export const APP_SESSION_STARTED = 'APP_SESSION_STARTED';
export const USER_SESSION_STARTED = 'USER_SESSION_STARTED';
export const SESSION_ACTIVITY = 'SESSION_ACTIVITY';
export const SESSION_TIMEOUT = 'SESSION_TIMEOUT';
export const SESSION_DESTROY = 'SESSION_DESTROY';

export const SESSION_METHOD_UNKNOWN = -1;
export const SESSION_METHOD_COLD_START = 1;
export const SESSION_METHOD_WARM_START = 2;

export const SESSION_TYPE_APP = 'app';
export const SESSION_TYPE_USER = 'user';

export const SESSION_ACTIVITY_THROTTLE_MS: number = config.sessionActivityThrottle;
export const SESSION_TIMEOUT_MS: number = config.sessionTimeout;
export const SESSION_LEVERS_THROTTLE_MS = 100;

export const SESSION_LEVERS_TTL_MS = ONE_WEEK;
